/*
 * @Author: Michael Lam 127068684+MichaelLam888@users.noreply.github.com
 * @Date: 2025-07-08 11:46:50
 * @LastEditTime: 2025-07-08 11:51:36
 * @Description: 
 */
// src/components/Footer.jsx
import React from 'react';
import '../css/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>All rights reserved by GLOBAL TP TECHNOLOGY LIMITED © 2025</p>
    </footer>
  );
};

export default Footer;
